import { Box } from '@interstate/components/Box';
import { Typography } from '@interstate/components/Typography';

import { formatDollarsAndCents } from '@makemydeal/dr-common-utils';
import type { FC } from 'react';

type TotalSummary = {
    totalType: string;
    totalValue: number;
};

export const TotalSummary: FC<TotalSummary> = ({ totalType, totalValue }) => {
    return (
        <>
            <Box display="grid" textAlign="end" alignItems="center" justifyContent="end" gap={'0.7rem'}>
                <Typography variant="label-md" color="sem.color.on-surface.muted">
                    {`Total ${totalType}`}
                </Typography>
                <Typography variant="h5" color="base.color.black" sx={{ textAlign: 'right' }}>
                    {formatDollarsAndCents(totalValue)}
                </Typography>
            </Box>
        </>
    );
};
